<template>
  <div
    v-if="hasError"
    class="invalid-feedback d-block"
    v-b-tooltip.hover="{ variant: 'base', delay: { show: 500, hide: 100 }, }"
    :title="fullErrorMessage"
  >
    {{ displayMessage }}
  </div>
</template>

<script>

export default {
  name: 'FieldErrorMessage',
  props: {
    // Backend error message (string or array)
    backendError: {
      type: [String, Array, null],
      default: null
    },
    // Frontend validation message
    frontendMessage: {
      type: String,
      default: 'Field is required'
    },
    // Show frontend validation error when true
    showFrontendError: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasError () {
      return this.backendError || this.showFrontendError
    },
    normalizedBackendError () {
      if (!this.backendError) return null
      return Array.isArray(this.backendError) ? this.backendError[0] : this.backendError
    },
    displayMessage () {
      return this.normalizedBackendError || this.frontendMessage
    },
    fullErrorMessage () {
      return this.displayMessage
    }
  }
}
</script>
